import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionUrlService {

  private secretKey = 'your-secret-key';  // Anahtar burada sabit, ama daha güvenli yöntemler kullanılabilir.

  constructor() { }

  // Şifreleme fonksiyonu
  // 🔐 Güvenli Base64 kodlama ile şifreleme
  encryptId(id: string): string {
    const encryptedId = CryptoJS.AES.encrypt(id, this.secretKey).toString();
    return encryptedId;
  }

  // Deşifreleme fonksiyonu
  decryptId(encryptedId: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedId, this.secretKey);
    const decryptedId = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedId;
  }
}